<template>
  <div class="paymentMethod" tabindex="-1" @blur="show = false">
    <div
      class="select_com"
      @click="show = !show"
      :class="{ active_select_box: show }"
    >
      <span v-if="platform.value">{{ platform.name }}</span>
      <template v-else>
        <slot></slot>
      </template>
      <img
        class="select_icon_com"
        src="@/assets/img/PC/recharge/selectdown.png"
        :class="{ rotate: show }"
      />
    </div>

    <div class="select_item_list" :class="{ active_select_item_list: show }">
      <div
        v-for="(item, index) in paymentChannel"
        :key="index"
        class="select_item_menu"
        :class="{ active_select_item_menu: platform.value == item.value }"
        @click="selectClick(item)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    countrySelected: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      show: false,
      value: "HaiPay",
      platform: {}, //支付方式
      paymentChannel: [
        {
          name: "HaiPay",
          value: 15,
          icon: require("@/assets/img/PC/recharge/haipay-icon.png"),
        },
        // {
        //   name: "Payermax",
        //   value: 7,
        //   icon: require("@/assets/img/PC/recharge/payerMax-icon.png"),
        // },
        {
          name: "USDT",
          value: 16,
        },
      ],
    };
  },
  computed: {},
  methods: {
    selectClick(item) {
      this.show = false;
      this.platform = item;
      console.log(item);
      this.$parent.setPmId(item);
    },
  },
};
</script>
<style scoped>
.paymentMethod {
  height: 58px;
  position: relative;
  margin-bottom: 30px;
}

.select_com {
  height: 50px;
  line-height: 50px;
  border-radius: 8px;
  opacity: 1;
  border: 1px solid #e4e8ef;
  background: #fff;
  overflow: hidden;
  position: relative;
  padding: 0px 45px 0px 20px;
  cursor: pointer;
  transition: all 0.2s;
}
.active_select_box {
  border-color: #6e3eff;
}
.select_icon_com {
  width: 24px;
  height: 24px;
  position: absolute;
  right: 17px;
  top: 13px;
  transition: all 0.2s;
}
.rotate {
  transform: rotateZ(180deg);
}

.select_item_list {
  margin-top: 2px;
  border-radius: 8px;
  opacity: 1;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.25);
  height: 0;
  max-height: 370px;
  overflow: auto;
  z-index: 999;
  position: absolute;
  width: 100%;
  box-sizing: border-box;
}

.active_select_item_list {
  height: auto;
}

.select_item_menu {
  box-sizing: border-box;
  padding: 9px 16px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

.active_select_item_menu {
  color: #6e3eff;
}

.select_item_menu:hover {
  background-color: #eee;
}
</style>
